import { MoveRight } from "lucide-react";
import { STEPS } from "../mock";
import { Reveal } from "./Reveal";

export const HowItWorks = () => (
  <section id="come-funziona" data-testid="how-it-works-section" className="bg-[#faf7f2] py-16 sm:py-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center max-w-2xl mx-auto">
        <span className="text-[#c8102e] font-condensed font-bold uppercase tracking-widest text-sm">Come funziona</span>
        <h2 className="font-condensed font-extrabold uppercase tracking-tight text-[#191512] text-3xl sm:text-4xl mt-2">
          Semplice come deve essere
        </h2>
        <p className="mt-4 text-slate-600 text-base sm:text-lg">
          Attivi il servizio in pochi minuti e sei subito coperto.
        </p>
      </Reveal>
      <div className="mt-14 flex flex-col lg:flex-row items-stretch justify-center gap-8 lg:gap-4">
        {STEPS.map((step, i) => (
          <Reveal key={step.number} delay={i * 0.15} className="flex flex-col lg:flex-row items-center flex-1">
            <div data-testid={`step-${step.number}`} className="flex flex-col items-center text-center max-w-xs mx-auto">
              <span className="flex items-center justify-center w-20 h-20 rounded-full bg-[#c8102e] text-white font-condensed font-black text-4xl shadow-lg shadow-[#c8102e]/30 ring-8 ring-[#c8102e]/10">
                {step.number}
              </span>
              <h3 className="mt-5 font-condensed font-bold uppercase tracking-tight text-[#191512] text-xl sm:text-2xl">
                {step.title}
              </h3>
              <p className="mt-2 text-slate-600 text-sm sm:text-base">{step.text}</p>
            </div>
            {i < STEPS.length - 1 && (
              <MoveRight
                data-testid={`step-arrow-${step.number}`}
                className="hidden lg:block w-10 h-10 text-[#1b7a46] mx-2 shrink-0 self-center"
                strokeWidth={2.5}
              />
            )}
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
